import { lazyWithPreload } from '../../navigation';

export const OrganizationContentScreen = lazyWithPreload(() =>
    import('./OrganizationContentScreen').then((m) => ({ default: m.OrganizationContentScreen }))
);
